export const filterByKind = (notes, kind) => notes.filter((n) => (n.kind || 'note') === kind)

export const filterBySearch = (notes, query) => {
    const q = query.trim().toLowerCase()
    if (!q) return notes
    return notes.filter(
        (n) =>
            (n.title || '').toLowerCase().includes(q) ||
            (n.content || '').toLowerCase().includes(q) ||
            (n.notes || '').toLowerCase().includes(q)
    )
}

export const filterByTags = (notes, activeTags) => {
    if (!activeTags || activeTags.size === 0) return notes
    return notes.filter((n) => Array.from(activeTags).every((t) => (n.tags || []).includes(t)))
}

export const filterByArchived = (notes, showArchived) =>
    showArchived ? notes.filter((n) => n.archived) : notes.filter((n) => !n.archived)

const pad = (n) => String(n).padStart(2, '0')
const todayStr = () => {
    const d = new Date()
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
}

export const filterByTaskTab = (tasks, tab) => {
    const today = todayStr()
    switch (tab) {
        case 'today':
            return tasks.filter((t) => t.dueAt === today)
        case 'upcoming':
            return tasks.filter((t) => t.dueAt && t.dueAt > today)
        case 'done':
            return tasks.filter((t) => t.done)
        case 'pinned':
            return tasks.filter((t) => t.pinned)
        default:
            return tasks
    }
}

export const filterByNoteTab = (notes, tab) => {
    switch (tab) {
        case 'pinned':
            return notes.filter((n) => n.pinned)
        case 'archived':
            return notes.filter((n) => n.archived)
        default:
            return notes.filter((n) => !n.archived)
    }
}

const compareTitle = (a, b) => (a.title || '').localeCompare(b.title || '')
const compareUpdated = (a, b) => new Date(b.updatedAt || 0) - new Date(a.updatedAt || 0)
const compareCreated = (a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0)
const compareDue = (a, b) => {
    const da = a.dueAt || '9999-99-99'
    const db = b.dueAt || '9999-99-99'
    return da < db ? -1 : da > db ? 1 : 0
}

const COMPARATORS = { title: compareTitle, updated: compareUpdated, created: compareCreated, due: compareDue }

export const sortNotes = (notes, sortKey) => {
    const cmp = COMPARATORS[sortKey] || compareUpdated
    return [...notes].sort((a, b) => {
        const pinDiff = (b.pinned ? 1 : 0) - (a.pinned ? 1 : 0)
        if (pinDiff !== 0) return pinDiff
        return cmp(a, b)
    })
}

/** Formats a bare "YYYY-MM-DD" string without any UTC/local timezone round-trip. */
export const formatDateOnly = (dateStr) => {
    if (!dateStr) return ''
    const [y, m, d] = dateStr.split('-').map(Number)
    if (!y || !m || !d) return ''
    return new Date(y, m - 1, d).toLocaleDateString()
}
